const ui = {
  search: 'Search',
  type_to_search: 'Type so search...',
  click_to_expand: 'Click to expand {{ count }} lines',
  click_to_collapse: 'Click to collapse {{ count }} lines',
  assets_portal: 'Assets portal',
  show_password: 'Show password',
  hide_password: 'Hide password',
} as const;

export default ui;
